import { rawTrackEngagementEvent } from '../../services/tracking/pulse';

const linkElementType = 'store-link';
const tabElementType = 'tab';

export const trackTabClick = (tab: string) =>
  rawTrackEngagementEvent({
    action: 'Click',
    object: {
      id: tab,
      type: 'UIElement',
      name: tab,
      elementType: tabElementType,
    },
  });

export const trackStoreLinkClick = (store: string) =>
  rawTrackEngagementEvent({
    action: 'Click',
    object: {
      id: store,
      type: 'UIElement',
      name: store,
      elementType: linkElementType,
    },
  });

export const trackHelpButtonClick = (option: string) =>
  rawTrackEngagementEvent({
    action: 'Click',
    object: {
      id: option,
      type: 'UIElement',
      name: option,
      elementType: 'help-button',
    },
  });

export const trackHelpCenterLinkClick = () =>
  rawTrackEngagementEvent({
    action: 'Click',
    object: {
      id: 'help-center',
      type: 'UIElement',
      name: 'help-center',
      elementType: 'help-center-link',
    },
  });
